import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as Bearer fallback for cross-site cookie issues
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("aq_token");
  if (token) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
});

export const imageUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return `${API}/files/${pathOrUrl}`;
};

export const buildWhatsappLink = (number, message) => {
  const cleaned = (number || "").replace(/[^\d+]/g, "");
  const text = encodeURIComponent(message || "Hello, I am interested in this watch model.");
  return `https://wa.me/${cleaned.replace(/^\+/, "")}?text=${text}`;
};
